import './Logo.scss';

import * as React from 'react';

type Props = {
  includeHover?: boolean;
};

export default function Logo({ includeHover }: Props) {
  return (
    <svg
      viewBox="0 0 600 600"
      className={includeHover ? 'Logo--includesHoverState' : 'Logo'}
    >
      <path
        className="Logo-background"
        fill="#000000"
        d="M592.2873535,0H7.712667C3.4524672,0,0,3.4544277,0,7.712667v584.574707
						C0,596.5455933,3.4524672,600,7.712667,600h584.574707C596.5475464,600,600,596.5455933,600,592.2873535V7.712667
						C600,3.4544277,596.5475464,0,592.2873535,0z"
      />
      <path
        fill="#FFFFFF"
        d="M265.228302,148.6109772c-3.0701599-3.0740967-8.0577087-3.0740967-11.1278839,0l-47.1817627,47.1817627
						l-47.1817627-47.1817627c-3.0701599-3.0740967-8.0577087-3.0740967-11.1278839,0
						c-3.0740814,3.0740814-3.0740814,8.0537872,0,11.1278839l47.1817627,47.1817627l-47.1817627,47.1817474
						c-3.0740814,3.0740814-3.0740814,8.0538177,0,11.1278839c1.5350952,1.5370483,3.5504913,2.3055725,5.5639496,2.3055725
						c2.013443,0,4.0288544-0.7685242,5.5639343-2.3055725l47.1817627-47.1817474l47.1817627,47.1817474
						c1.53508,1.5370483,3.5504913,2.3055725,5.5639496,2.3055725c2.0134277,0,4.0288391-0.7685242,5.5639343-2.3055725
						c3.0740967-3.0740662,3.0740967-8.0538025,0-11.1278839l-47.1817627-47.1817474l47.1817627-47.1817627
						C268.3023987,156.6647644,268.3023987,151.6850586,265.228302,148.6109772z M393.0813293,267.5358276
						c33.4228821,0,60.6152344-27.1923523,60.6152344-60.6152039s-27.1923523-60.6152191-60.6152344-60.6152191
						s-60.6152039,27.1923523-60.6152039,60.6152191S359.6584778,267.5358276,393.0813293,267.5358276z M393.0813293,162.0444183
						c24.745636,0,44.8762207,20.1305847,44.8762207,44.8762054s-20.1305847,44.8761902-44.8762207,44.8761902
						c-24.7456055,0-44.8761902-20.1305695-44.8761902-44.8761902S368.3357239,162.0444183,393.0813293,162.0444183z
						M265.228302,334.7697449c-3.0701599-3.0740967-8.0577087-3.0740967-11.1278839,0l-47.1817627,47.1837158l-47.1817627-47.1837158
						c-3.0701599-3.0740967-8.0577087-3.0740967-11.1278839,0c-3.0740814,3.0740662-3.0740814,8.0538025,0,11.1278687
						l47.1817627,47.1837158l-47.1817627,47.1837463c-3.0740814,3.0740662-3.0740814,8.053772,0,11.1278687
						c1.5350952,1.5370483,3.5504913,2.3055725,5.5639496,2.3055725c2.013443,0,4.0288544-0.7685242,5.5639343-2.3055725
						l47.1817627-47.1837158l47.1817627,47.1837158c1.53508,1.5370483,3.5504913,2.3055725,5.5639496,2.3055725
						c2.0134277,0,4.0288391-0.7685242,5.5639343-2.3055725c3.0740967-3.0740967,3.0740967-8.0538025,0-11.1278687
						l-47.1817627-47.1837463l47.1817627-47.1837158C268.3023987,342.8235474,268.3023987,337.843811,265.228302,334.7697449z
						M393.0813293,332.4641724c-33.4228516,0-60.6152039,27.1923523-60.6152039,60.6152039
						c0,33.4267883,27.1923523,60.6191406,60.6152039,60.6191406s60.6152344-27.1923523,60.6152344-60.6191406
						C453.6965637,359.6565247,426.5042114,332.4641724,393.0813293,332.4641724z M393.0813293,437.9595032
						c-24.7456055,0-44.8761902-20.134491-44.8761902-44.880127c0-24.7456055,20.1305847-44.8761902,44.8761902-44.8761902
						c24.745636,0,44.8762207,20.1305847,44.8762207,44.8761902C437.95755,417.8250122,417.8269653,437.9595032,393.0813293,437.9595032z
						"
      />
    </svg>
  );
}
